import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'findPurely',
    standalone: false
})
export class FindPurelyPipe implements PipeTransform {
  transform<T>(items: T[], findFn: (i: T) => boolean): T | undefined {
    if (!items || !findFn) return undefined;

    return items.find(findFn);
  }
}
